import * as React from 'react';
import {useStore} from 'react-redux';
import useLabelTranslation from 'src/hooks/useLabelTranslation';

import {Gif} from '@giphy/react-components';
import {GiphyFetch} from '@giphy/js-fetch-api';
import type {GifsResult} from '@giphy/js-fetch-api';
import type {IGif} from '@giphy/js-types';

import {debounceAsync} from 'src/utils/index';

import css from './gif-picker.css';


const searchGif = async (
  searchString: string,
  gf: GiphyFetch,
): Promise<GifsResult | undefined> => {
  if (searchString) {
    return gf.search(searchString);
  }
  return undefined;
};
const searchGifDebounced = debounceAsync(searchGif, 1000);

export default function GifPicker({
  onClose,
  onSelect,
}: {
  onClose: () => unknown;
  onSelect: (arg1: unknown) => void;
}) {
  const {t} = useLabelTranslation();
  const reduxStore = useStore();
  const giphyKey = reduxStore.getState().env.vendorIds.giphy;
  const gf = new GiphyFetch(giphyKey);
  const [gifs, setGif] = React.useState<IGif[] | null>(null);
  React.useEffect(() => {
    gf.trending({offset: 15, limit: 15}).then(({data}) => setGif(data));
  }, []);

  const [searchString, setSearchString] = React.useState('');

  const handleSearchStringChange = async (text: string) => {
    setSearchString(text);
    const result = await searchGifDebounced(text, gf);
    if (result?.data) {
      setGif(result.data);
    }
  };

  return (
    <div className={css.root}>
      <input
        type="search"
        placeholder={`${t('Search_gifs', 'Search gifs')}...`}
        className={css.searchInput}
        value={searchString}
        onChange={(e) => {
          handleSearchStringChange(e.target.value);
        }}
      />
      {gifs && (
        <div className={css.gifContainer}>
          {gifs.map((gif) => (
            <Gif
              key={gif.id}
              noLink
              gif={gif}
              width={180}
              onGifClick={() => {
                onSelect(gif);
                onClose();
              }}
            />
          ))}
        </div>
      )}
      <img src="/images/powered-by-giphy.png" className={css.poweredBy} />
    </div>
  );
}
